<script lang="js">
import CTA from "@/components/CTA.vue";
import departmentsData from "@/data/departments.json";

export default {
  name: 'Program',
  data() {
    return {
      departmentData: null
    }
  },
  methods: {
        loadDepartment() {
      const slug = this.$route.params.slug.toLowerCase().replace(/-/g, ' ')

      for (const school of departmentsData.schools) {
        for (const dept of school.departments) {
          if (dept.name.toLowerCase() === slug) {
            this.departmentData = { ...dept, schoolName: school.name }
            console.log("Debug Data:", this.departmentData);
            return
          }
        }
      }

       // Optionally handle if no department found
      this.departmentData = null
    }
  },
  mounted() {
        this.loadDepartment()
   },
     watch: {
    '$route.params.slug': function () {
      this.loadDepartment()
    }
  },
  computed: {},
  components: { CTA },
  created: function () { }
}
</script>

<template>
  <div v-if="departmentData" class="container-fluid px-0">
    <div class="bg-image-overlay">
      <div class="overlay"></div>
      <div class="content">
        <h1 class="text-uppercase fw-bold" v-scrollanimation.once="'fadeInUp'">
          {{ departmentData.name }}
        </h1>
      </div>
    </div>
    <div class="p-5 bg-light">
      <p class="text-start">
        {{ departmentData.intro }}
      </p>
    </div>

    <div class="row m-0 py-5 d-flex align-items-stretch">
      <div class="col-md-5 h-100">
        <img
          src="https://placehold.jp/500x500.png"
          class="shadow-lg w-100 h-100 object-fit-cover"
          alt="HOD"
        />
      </div>
      <div class="col-md-7 text-start h-100">
        <h3 class="text-uppercase fcp-text-primary">
          Welcome to <br />
          <b> {{ departmentData.name }}</b>
        </h3>
        <p>
          {{ departmentData.hod.message }}
        </p>
        <p>
          - <br />
          <b> {{ departmentData.hod.name }}</b> <br />
          <span class="fst-italic">
            Head, Department of {{ departmentData.name }}</span
          >
        </p>
        <hr />
        <p>
          <b class="small">Get in touch with us:</b> <br />
          <span>
            <i class="bi bi-envelope-at me-2"></i>
            <a class="text-decoration-none" href="mailto:">
              {{ departmentData.email }}
            </a>
          </span>
        </p>
      </div>
    </div>

    <div class="row m-0 bg-light text-start p-5">
      <h5 class="text-uppercase fcp-text-primary fw-bolder">PROGRAMMES</h5>
      <p>
        The following academic programmes are offered under the
        {{ departmentData.name }} department at {{ departmentData.schoolName }}.
        These programmes are carefully designed to equip students with the
        knowledge, practical skills, and professional competencies required to
        thrive in their respective fields.
      </p>
      <ul>
        <li v-for="(program, index) in departmentData.programs" :key="index">
          {{ program }}
        </li>
      </ul>
      <p>
        The {{ departmentData.name }} department currently offers both National
        Diploma (ND) and Higher National Diploma (HND) programmes, available in
        both Full-Time and Part-Time study options, providing flexibility for
        working professionals and regular students alike.
      </p>
      <p>
        Prospective applicants are expected to possess a minimum of five (5)
        credit passes in relevant subjects including English Language and
        Mathematics at not more than two sittings in examinations like WAEC,
        NECO, or NABTEB, etc. For further details on admission requirements,
        programme structure, and application procedures, kindly contact the
        department via email at
        <a
          href="mailto:{{ departmentData.email }}"
          class="fst-italic link-offset-2 link-offset-3-hover link-underline link-underline-opacity-0 link-underline-opacity-75-hover"
          >{{ departmentData.email }}</a
        >
        or reach out to the Admissions Office for guidance.
      </p>
    </div>

    <div class="text-start p-5">
      <h5 class="text-uppercase fcp-text-primary fw-bolder">Staffs</h5>
      <div class="row">
        <div
          class="col-sm"
          v-for="(staff, index) in departmentData.staff"
          :key="index"
        >
          <div class="p-3">
            <img src="https://placehold.jp/200x200.png" class="" alt="staff" />
            <h6 class="mt-2">{{ staff.name }}</h6>
          </div>
        </div>
      </div>
    </div>

    <CTA
      heading="Start Your Academic Journey Today!"
      message="Admissions are now open for the 2026/2027 academic session. Take the first step towards achieving your educational goals by applying today."
      :link="$urlHelper.getApplyPath()"
      button="Apply Now"
      v-scrollanimation.once="'zoomIn'"
    />
  </div>
</template>
<style scoped>
.bg-image-overlay {
  position: relative;
  background-image: url("@/assets/img/bg2.png");
  background-size: cover;
  background-position: center;
  height: 400px;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  color: white;
}

.overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: #0e1438dc;
  z-index: 1;
}

.content {
  position: relative;
  z-index: 2;
}
</style>
